export default "__VITE_ASSET__wdFYb$_y__"